import { useMemo } from 'react';
import { useQuery } from 'react-query';
import NameSuffixService from '../../services/nameSuffixService';

const placeholderData = [];

// Shares the 'name-suffixes' key with every other caller, so the list is
// fetched once. Options come back bare; a placeholder entry, where a form
// wants one, is the caller's to add.
const useNameSuffixesQuery = () => {
  const { data, isLoading } = useQuery(
    'name-suffixes',
    () => new NameSuffixService().getAll(),
    { placeholderData, refetchOnWindowFocus: false },
  );

  const nameSuffixOptions = useMemo(
    () =>
      (Array.isArray(data) ? data : []).map(({ id, name }) => ({
        value: id,
        text: name,
      })),
    [data],
  );

  return { nameSuffixOptions, isLoading };
};

export default useNameSuffixesQuery;
